import React from 'react';
import PropTypes from 'prop-types';
import style from './WidgetWrapper.module.css';

const WidgetWrapper = ({ children }) => (
  <div className={`${style.WidgetWrapper}`}>
    {children}
  </div>
);

WidgetWrapper.propTypes = {
  children: PropTypes.node,
};

export default WidgetWrapper;


